import { render, staticRenderFns } from "./LastPageCell.vue?vue&type=template&id=3b7a1bc0&scoped=true&"
import script from "./LastPageCell.vue?vue&type=script&lang=js&"
export * from "./LastPageCell.vue?vue&type=script&lang=js&"
import style0 from "./LastPageCell.vue?vue&type=style&index=0&id=3b7a1bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a1bc0",
  null
  
)

export default component.exports